export const sharedData = {
	lang: "ru",
	lastRewordTime: "",
};
